module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAABIElEQVQ4jYXTW0rEQBBA0VvZhEvxiYj4KnELbqR/xA97GYIbEGRgyici4+iyWjp0ihknU9NfCRxuqpO0ML17AraKph2CJZZ7B6x1HfAIbIvlryg2OGCt64qmB+AUOBTLP0HMHTDq6mQUTe/AGbArlr+DoDtgxXXDRdH0BlwC+2J5FgTdAUuuW7wpmgw4Bw7E8m8QdAe46/6roukVuKhfTSzPg6A7YD4aa8GXBvfEsgVBd3Xa0dhC8KbhaLlbGxPLNXILPG+IuRuNieWr9pI/iiYNQu4AXYm10KT+6UXTyYbQpJ2I3i3FxLI2MCuajoKQO8Cdx9pE07a1emSiiXrXjpavPiaWr9uTPjdszd2wtaWYWK71+/oTFk3HQcgdsOqAP3uFZ4tGoNN7AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/next_type.png
// module id = Qb11
// module chunks = 10